import { render, staticRenderFns } from "./DecisionInput.vue?vue&type=template&id=2b8c99ae"
import script from "./DecisionInput.vue?vue&type=script&lang=js"
export * from "./DecisionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports